import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsComponent } from './cms.component';
import { SafeHtmlPipe } from '../../pipe/safe-html.pipe';

@NgModule({
    declarations: [CmsComponent, SafeHtmlPipe],
    imports: [CommonModule],
    exports: [CmsComponent],
})
export class CmsModule {}
